import { router } from "./general/route";
import { RouterProvider } from "react-router-dom";
import { persistor, store } from "./app/store";
import { Provider } from "react-redux";
import { enUS, vi } from "date-fns/locale";
import { AppToast } from "./general/component/toast";
import "react-toastify/dist/ReactToastify.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import { setDefaultOptions } from "date-fns";
import { PersistGate } from "redux-persist/integration/react";
import "swiper/swiper-bundle.css";
import { I18nextProvider, useTranslation } from "react-i18next";
import { useEffect } from "react";
import i18 from "./i18n";
import "./App.css";
import "./asset/font_awesome_6_pro/css/all.css";
import { ModalImage, ModalVideo } from "./general/component/modal";
import { LicenseInfo } from "@mui/x-license";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import "dayjs/locale/vi";

LicenseInfo.setLicenseKey(
  "e0d9bb8070ce0054c9d9ecb6e82cb58fTz0wLEU9MzI0NzIxNDQwMDAwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y",
);

function App() {
  const { i18n } = useTranslation();
  useEffect(() => {
    switch (i18n.language) {
      case "en":
        setDefaultOptions({ locale: enUS });
        break;
      case "vi":
        setDefaultOptions({ locale: vi });
        break;
      default:
        setDefaultOptions({ locale: vi });
        break;
    }
  }, [i18n]);

  useEffect(() => {
    const handleError = (event) => {
      if (event.message.includes("removeChild")) {
        console.warn("Gặp lỗi");
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/auth/sign-in";
      }
    };

    const handlePromiseRejection = (event) => {
      const msg = event.reason?.message || "";
      if (msg.includes("removeChild")) {
        localStorage.clear();
        window.location.href = "/auth/sign-in";
      }
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handlePromiseRejection);

    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener("unhandledrejection", handlePromiseRejection);
    };
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"vi"}>
            <AppToast></AppToast>
            <ModalImage></ModalImage>
            <ModalVideo></ModalVideo>
            <RouterProvider router={router} />
          </LocalizationProvider>
        </I18nextProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
